/** Форматирует телефон (10 цифр или любой формат) для отображения: +7 (999) 123-12-32 */
export function formatPhoneDisplay(raw) {
  if (!raw) return '';
  const d = raw.replace(/\D/g, '');
  let n = d;
  if (n.length >= 11 && (n[0] === '7' || n[0] === '8')) n = n.slice(1);
  if (n.length === 0) return raw;
  let r = '+7 (' + n.slice(0, 3);
  if (n.length >= 3) r += ') ';
  if (n.length > 3) r += n.slice(3, 6);
  if (n.length > 6) r += '-' + n.slice(6, 8);
  if (n.length > 8) r += '-' + n.slice(8, 10);
  return r;
}

/** Возвращает tel: ссылку в формате +7XXXXXXXXXX */
export function phoneTelHref(raw) {
  if (!raw) return '';
  let d = raw.replace(/\D/g, '');
  // Код страны срезаем только у 11-значного номера (как в formatPhoneDisplay):
  // у 10-значного городского 843… (Казань) восьмёрка — часть кода города.
  if (d.length >= 11 && (d[0] === '7' || d[0] === '8')) d = d.slice(1);
  return `tel:+7${d}`;
}

/** Ответ /delivery/calculate с requires_negotiation → { distance, maxKm }.
 *  zone приходит подписью «более 21 км»: parseInt с неё даёт NaN, и окно создания
 *  заказа подставляло захардкоженное 15 вместо границы из тарифов. */
export function deliveryOutOfRangeInfo(result) {
  const m = String(result?.zone || '').match(/\d+(?:[.,]\d+)?/);
  return { distance: result?.distance, maxKm: m ? m[0] : null };
}

/** Подсказка под стоимостью доставки для адреса вне тарифной сетки. */
export function deliveryOutOfRangeText({ distance, maxKm }) {
  if (distance === '?') return 'Не удалось определить координаты адреса. Укажите стоимость доставки вручную.';
  return `Адрес за пределами ${maxKm ? `${maxKm} км` : 'зоны доставки'} (${distance} км). Укажите стоимость вручную.`;
}

// «0 заказов, 1 заказ, 2 заказа, 11 заказов, 21 заказ» (было «0 заказа», «21 заказов»)
export function ordersWord(n) {
  const m10 = n % 10, m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return 'заказ';
  return m10 >= 2 && m10 <= 4 && !(m100 >= 12 && m100 <= 14) ? 'заказа' : 'заказов';
}
